import React from 'react';
import styled from 'styled-components';

import { translate } from '~/services/translate';
import { ColumnFlexCentered } from '~/components/basic/containers';
import mainTheme from '~/core/theme';
import MarketingFeature from '~/components/basic/marketing-feature'

const Container = styled(ColumnFlexCentered)`
  width: 600px;
  align-items: flex-start;
`;

const Title = styled.div`
  font-weight: 500;
  font-size: 32px;
  margin-bottom: 24px;
  font-family: 'Roboto Slab', serif;
`;

const FeaturesContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-family: 'Roboto', sans-serif;

  & > *:not(:first-child) {
    margin-top: 12px;
  }
`;

const LargeFeaturesPanel = () => (
  <Container fullWidth>
    <Title>{ translate('vpaas_marketing_pane_title') }</Title>
    <FeaturesContainer>
      <MarketingFeature text={ translate('vpaas_marketing_feature_1') } fontSize={ 16 } color={ mainTheme.darkFont } />
      <MarketingFeature text={ translate('vpaas_marketing_feature_2') } fontSize={ 16 } color={ mainTheme.darkFont } />
      <MarketingFeature text={ translate('vpaas_marketing_feature_3') } fontSize={ 16 } color={ mainTheme.darkFont } />
      <MarketingFeature text={ translate('vpaas_marketing_feature_4') } fontSize={ 16 } color={ mainTheme.darkFont } />
      <MarketingFeature text={ translate('vpaas_marketing_feature_5') } fontSize={ 16 } color={ mainTheme.darkFont } />
      <MarketingFeature text={ translate('vpaas_marketing_feature_6') } fontSize={ 16 } color={ mainTheme.darkFont } />
    </FeaturesContainer>
  </Container>
);

export default LargeFeaturesPanel;